module.exports = __webpack_public_path__ + "static/media/facebook.89c92ccd.svg";